import { reactive } from "vue";

const GStore = reactive({ flashMessage: "", event: "null" });
export default GStore;
